import Link from "next/link";
import { Button } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { AppShell } from "@chef/feature-app-shell";
import { Check } from "@chef/icons/small";
import { intl } from "./DeleteAccountRequestSentPage.Intl";

export const DeleteAccountRequestSentPage = () => {
  return (
    <AppShell title={intl.DELETE_ACCOUNT}>
      <AppShell.Meta />
      <AppShell.Header />
      <AppShell.Main grid>
        <div className="flex flex-col items-center gap-6 text-center col-span-full md:col-span-6 md:col-start-2 lg:col-span-4 lg:col-start-3 xl:col-start-5 md:mt-48">
          <div className="flex items-center justify-center py-8 rounded-full bg-grey-3 px-7">
            <Check className="w-10 h-8" />
          </div>

          <h1 className="text-2xl">
            <strong>
              {intl.YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_HAS_BEEN_RECEIVED}
            </strong>
          </h1>

          <p className="mt-2">{intl.FOR_SECURITY_REASONS}</p>

          <Link href={BRAND_PATHS.MY_MENU_PAGE} passHref legacyBehavior>
            <Button primary>{intl.I_UNDERSTAND}</Button>
          </Link>

          <div className="mt-6">
            <p>
              <span>{intl.CONFIRM_THAT} </span>
              <Link
                href={BRAND_PATHS.PAYMENT_LINK}
                passHref
                className="underline"
              >
                <strong>{intl.OUTSTANDING_PAYMENTS_EXISTS}</strong>
              </Link>
            </p>
            <p>
              <span>{intl.DO_YOU_HAVE_OTHER_QUESTIONS} </span>
              <Link
                href={BRAND_PATHS.CONTACT_US_PAGE}
                passHref
                className="underline"
              >
                <strong>{intl.CONTACT_SUPPORT}</strong>
              </Link>
            </p>
          </div>
        </div>
      </AppShell.Main>
      <AppShell.TabBar />
    </AppShell>
  );
};
